module.exports = __webpack_public_path__ + "img/103.d11fd20d.jpg";